import type { track as trackEn } from '../en/track';

export const track: typeof trackEn = {
  title: 'Registrar',

  hero: {
    sinceLastFeed: 'Desde la última toma',
    nextSide: (side) =>
      side === 'left' ? 'Sigue el lado izquierdo' : 'Sigue el lado derecho',
    emptyTitle: 'Todo listo para empezar',
    emptyBody: 'Registre la primera toma y nosotros le llevamos la cuenta del tiempo.',
  },

  cards: {
    feed: 'Alimentar',
    feedActive: 'Toma en curso',
    resume: 'Toque para continuar',
    diaper: 'Pañal',
    pump: 'Extraer',
    sleep: 'Sueño',
    weight: 'Peso',
  },

  feedSheet: {
    title: 'Registrar una toma',
    editTitle: 'Editar toma',
    modeLabel: '¿Cómo desea registrarla?',
    modes: {
      timer: 'Cronómetro',
      bottle: 'Biberón',
      manual: 'A mano',
    },
  },

  timer: {
    tapToStart: 'Toque el lado con el que empieza su bebé. Toque de nuevo para pausar.',
    session: 'Total de la sesión',
    finish: 'Terminar la toma',
    discard: 'Descartar esta toma',
    confirmDiscard: '¿Descartar esta toma? El cronómetro se borrará.',
  },

  bottle: {
    amount: 'Cantidad',
    contents: '¿Qué contiene el biberón?',
    increase: 'Aumentar la cantidad',
    decrease: 'Reducir la cantidad',
  },

  manual: {
    left: 'Minutos en el izquierdo',
    right: 'Minutos en el derecho',
  },

  fields: {
    time: 'Hora',
    startTime: 'Hora de inicio',
    note: 'Nota',
    notePlaceholder: 'Algo que quiera recordar (opcional)',
  },
};
